import * as React from 'react';

function SvgTick(props) {
  return (
    <svg viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2.64 4.9a1.27 1.27 0 00-1.8.02l-.47.47a1.27 1.27 0 000 1.8l4.46 4.45c.25.25.57.37.9.37a1.3 1.3 0 00.9-.38l9-9c.5-.5.5-1.3 0-1.8l-.48-.47a1.28 1.28 0 00-1.8 0L5.73 8l-3.1-3.1z" />
    </svg>
  );
}

export default SvgTick;
